// src/styled-system-props.ts
var UnsafePrefix = "UNSAFE_";

export { UnsafePrefix };
